import { useNavigate } from "react-router-dom";
import MainContainer from "../../layout/MainContainer";
import {
  Box,
  Tabs,
  Tab,
  IconButton,
  MenuItem,
  Select,
  SelectChangeEvent,
  Tooltip,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import SearchBar from "../../components/SearchBar";
import {
  useDeleteTicketMutation,
  useLazyDeleteQueryQuery,
  useLazyGetCustomerSupportQuery,
} from "../../services/main";
import { CustomerSupport } from "../../types/General";
import { CUSTOMER_QUERY, ROLES } from "../../utils/enums";
import { isValidInput } from "../../utils/validations";
import TableComponent from "../../components/TableComponent";
import { GridColDef } from "@mui/x-data-grid";
import AddReply from "../../Modals/addReply";
import moment from "moment";
import { showError, showToast, showWarning } from "../../constants/toasts";
import { ConfirmationModal } from "../../Modals/confirmationModal";
import usePermission from "../../hooks/usePermission";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const ManageCustomerSupport = () => {
  const navigate = useNavigate();
  const [getSupport] = useLazyGetCustomerSupportQuery();
  const [addReplyMethod] = useDeleteTicketMutation();
  const [deleteMethod] = useLazyDeleteQueryQuery();
  const {isAdd,isDelete,isView} =  usePermission({label:"Manage Customer Support",page_permission:"isView"})
  const [valueTabs, setValueTabs] = React.useState(0);
  const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
    setValueTabs(newValue);
  };

  const [valueTabs1, setValueTabs1] = React.useState(0);
  const handleChangeTabs1 = (event: React.SyntheticEvent, newValue: number) => {
    setValueTabs1(newValue);
  };

  const [searchTerm, setSearchTerm] = useState("");
  const [page, setPage] = useState<number>(1);
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState<string>("");
  const [isLoading, setIsLoading] = useState(false);
  const [rows, setRows] = useState<CustomerSupport[]>([]);
  const [openDelete, setOpenDelete] = useState(false);
  const [count, setCount] = useState(0);

  const [reply, setReply] = useState("");
  const [open, setOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState<CustomerSupport | null>(null);

  const handlePageChange = (event: any, newPage: number) => {
    setPage(newPage + 1);
  };

  const handleStatusUpdate = async (id: string) => {
    if (!reply) {
      showWarning("Please enter reply");
      return;
    }
    const body = {
      revert: reply || "",
      ticketId: id,
    };
    try {
      const response = await addReplyMethod(body).unwrap();
      if (response?.statusCode === 200) {
        showToast("Revert send to user");
        getAllList();
        setOpen(false);
      } else {
        showError("Please try again");
      }
    } catch (error: any) {
      console.log(error, "errror");
      showError(error?.data?.message || "");
    }
  };

  const columns: GridColDef<(typeof rows)[number]>[] = [
    {
      flex: 1,
      minWidth: 220,
      field: "name",
      headerName: "Owner Detail",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div
            className="user_block click_action"
            onClick={() =>
              navigate(`/manage-customers/detail/${row?.user?._id}`)
            }
          >
            <figure>
              <img
                src={
                  row?.user?.image || '"/static/images/user_placeholder.png"'
                }
                alt=""
              />
            </figure>
            <p>
              <b>{row?.user?.fullName || ""}</b>{" "}
              <span>{row?.user?.email || ""}</span>
            </p>
          </div>
        );
      },
    },
    {
      flex: 2,
      minWidth: 220,
      field: "title",
      headerName: "Query Title",
      editable: false,
      sortable: false,
    },
    {
      flex: 2,
      minWidth: 220,
      field: "description",
      headerName: "Query Description",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <Tooltip title={row?.description || ""} arrow>
            <div className="user_block">
              <p>{row?.description || ""}</p>
            </div>
          </Tooltip>
        );
      },
    },
    {
      flex: 1,
      minWidth: 150,
      field: "date",
      headerName: "Created Date",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <p>{moment(row?.createdAt).format("DD MMM YYYY")}</p>
          </div>
        );
      },
    },
    {
      minWidth: 180,
      field: "status",
      headerName: "Status",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <p>
              {row?.status === CUSTOMER_QUERY.PENDING ? "Pending" : "Resolved"}
            </p>
          </div>
        );
      },
    },
    {
      minWidth: 100,
      field: "action",
      headerName: "Action",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div className="table_actions v2">
            <Box>
              <IconButton
                onClick={() => {
                  setSelectedRow(row);
                  setOpen(true);
                }}
              >
                <img src="/static/images/reply_icon.svg" alt="" />
              </IconButton>
            </Box>
           {isDelete && <Box>
              <IconButton
                onClick={() => {
                  setSelectedRow(row);
                  setOpenDelete(true);
                }}
              >
                <img src="/static/images/trash2_icon.svg" alt="" />
              </IconButton>
            </Box>}
          </div>
        );
      },
    },
  ];

  const columnsResolved: GridColDef<(typeof rows)[number]>[] = [
    {
      flex: 1,
      minWidth: 220,
      field: "name",
      headerName: "Owner Detail",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div
            className="user_block click_action"
            onClick={() =>
              navigate(`/manage-customers/detail/${row?.user?._id}`)
            }
          >
            <figure>
              <img
                src={
                  row?.user?.image || '"/static/images/user_placeholder.png"'
                }
                alt=""
              />
            </figure>
            <p>
              <b>{row?.user?.fullName || ""}</b>{" "}
              <span>{row?.user?.email || ""}</span>
            </p>
          </div>
        );
      },
    },
    {
      flex: 2,
      minWidth: 220,
      field: "title",
      headerName: "Query Title",
      editable: false,
      sortable: false,
    },
    {
      flex: 2,
      minWidth: 220,
      field: "description",
      headerName: "Query Description",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <Tooltip title={row?.description || ""} arrow>
            <div className="user_block">
              <p>{row?.description || ""}</p>
            </div>
          </Tooltip>
        );
      },
    },
    {
      flex: 1,
      minWidth: 150,
      field: "date",
      headerName: "Created Date",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <p>{moment(row?.createdAt).format("DD MMM YYYY")}</p>
          </div>
        );
      },
    },
    {
      minWidth: 180,
      field: "status",
      headerName: "Status",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <p>
              {row?.status === CUSTOMER_QUERY.PENDING ? "Pending" : "Resolved"}
            </p>
          </div>
        );
      },
    },
  ];

  const getAllList = async () => {
    setIsLoading(true);
    try {
      const response = await getSupport({
        page,
        limit: 10,
        search: debouncedSearchTerm.trim(),
        status: valueTabs1 + 1,
        role: valueTabs === 0 ? ROLES.USER : ROLES.MAINTAINER,
      }).unwrap();
      if (response?.statusCode === 200) {
        setIsLoading(false);
        setRows(response?.data?.data || []);
        setCount(response?.data?.count);
      }
    } catch (error) {
      setIsLoading(false);
    }
  };

  const handleDelete = async () => {
    setIsLoading(true);
    const body = {
      ticketId: selectedRow?._id || "",
    };
    try {
      const response = await deleteMethod(body).unwrap();
      setIsLoading(false);

      if (response?.statusCode === 200) {
        showToast("Query Deleted successfully");
        getAllList();
      }
    } catch (error: any) {
      showError(error?.data?.message || "");
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getAllList();
  }, [debouncedSearchTerm, page, valueTabs, valueTabs1]);

  return (
    <MainContainer>
      <div className="main_title">
        <h1>Manage Customer Support</h1>
        <p>
          <span onClick={() => navigate("/dashboard")}>Dashboard</span> - Manage
          Customer Support
        </p>
      </div>

      <div className="table_header">
        <div className="left_s">
          <Box className="custom_tabs1" sx={{ width: "100%" }}>
            <Tabs
              value={valueTabs}
              onChange={handleChangeTabs}
              aria-label="basic tabs example"
              className="custom_tabs_links"
            >
              <Tab label="Property Owner" {...a11yProps(0)} />
              <Tab label="Maintenance Team" {...a11yProps(1)} />
            </Tabs>
          </Box>
        </div>
      </div>

      <div className="cards">
        <CustomTabPanel value={valueTabs} index={0}>
          <Box className="custom_tabs" sx={{ width: "100%" }}>
            <Tabs
              value={valueTabs1}
              onChange={handleChangeTabs1}
              aria-label="basic tabs example"
              className="custom_tabs_links"
            >
              <Tab label="Pending" {...a11yProps(0)} />
              <Tab label="Resolved" {...a11yProps(1)} />
            </Tabs>

            <div className="table_header">
              <div className="left_s">
                <Box className="search_box">
                  <SearchBar
                    searchTerm={searchTerm}
                    placeholder="Search..."
                    setDebouncedSearchTerm={setDebouncedSearchTerm}
                    value={searchTerm}
                    onCross={() => setSearchTerm("")}
                    onChange={(val: any) => {
                      if (isValidInput(val.target.value)) {
                        setSearchTerm(val.target.value);
                      }
                    }}
                  />
                </Box>
              </div>
            </div>
            <CustomTabPanel value={valueTabs1} index={0}>
              <div className="sorting_table">
                <TableComponent
                  columns={columns}
                  rows={rows}
                  count={count}
                  page={page}
                  onPageChange={handlePageChange}
                  loading={isLoading}
                />
              </div>
            </CustomTabPanel>
            <CustomTabPanel value={valueTabs1} index={1}>
              <div className="sorting_table">
                <TableComponent
                  columns={columnsResolved}
                  rows={rows}
                  count={count}
                  page={page}
                  onPageChange={handlePageChange}
                  loading={isLoading}
                />
              </div>
            </CustomTabPanel>
          </Box>
        </CustomTabPanel>
        <CustomTabPanel value={valueTabs} index={1}>
          <Box className="custom_tabs" sx={{ width: "100%" }}>
            <Tabs
              value={valueTabs1}
              onChange={handleChangeTabs1}
              aria-label="basic tabs example"
              className="custom_tabs_links"
            >
              <Tab label="Pending" {...a11yProps(0)} />
              <Tab label="Resolved" {...a11yProps(1)} />
            </Tabs>

            <div className="table_header">
              <div className="left_s">
                <Box className="search_box">
                  <SearchBar
                    searchTerm={searchTerm}
                    placeholder="Search..."
                    setDebouncedSearchTerm={setDebouncedSearchTerm}
                    value={searchTerm}
                    onCross={() => setSearchTerm("")}
                    onChange={(val: any) => {
                      if (isValidInput(val.target.value)) {
                        setSearchTerm(val.target.value);
                      }
                    }}
                  />
                </Box>
              </div>
            </div>
            <CustomTabPanel value={valueTabs1} index={0}>
              <div className="sorting_table">
                <TableComponent
                  columns={columns}
                  rows={rows}
                  count={count}
                  page={page}
                  onPageChange={handlePageChange}
                  loading={isLoading}
                />
              </div>
            </CustomTabPanel>
            <CustomTabPanel value={valueTabs1} index={1}>
              <div className="sorting_table">
                <TableComponent
                  columns={columnsResolved}
                  rows={rows}
                  count={count}
                  page={page}
                  onPageChange={handlePageChange}
                  loading={isLoading}
                />
              </div>
            </CustomTabPanel>
          </Box>
        </CustomTabPanel>
      </div>
      <AddReply
        open={open}
        onClose={handleStatusUpdate}
        setOpen={setOpen}
        selectedRow={selectedRow}
        setReply={setReply}
        reply={reply}
      />
      <ConfirmationModal
        text="Are you sure to delete this customer"
        openModal={openDelete}
        setOpenModal={setOpenDelete}
        handleSubmit={handleDelete}
      />
    </MainContainer>
  );
};

export default ManageCustomerSupport;
